<div style="margin:0px; background-color:#9fa8da;color:white;border-bottom:1px solid #a9a9a9;height:53px;" class="print-ignore">
    <div mat-dialog-title style="display:inline-block;color:white;">
        Student Information View
    </div>
    <div style="float:right; position:relative;padding-top:5px;">
        <tyl-button id="studentInfoCloseButton" image="topbarprint.png" label="Print" (clickEvent)="printClick()"></tyl-button>
        <tyl-button id="studentInfoCloseButton" image="cancel white.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</div>

<div style="display:flex; overflow:auto; height:100%;">
    <ng-template #StudentInfo student-information style="display:flex; flex-direction:column; flex:1;"></ng-template>
</div>